import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

export type NcImgType = 'base64' | 'file';

@Component({
    selector: 'nc-img-clip',
    templateUrl: './img-clip.component.html',
    styleUrls: ['./img-clip.component.less']
})
export class ImgClipComponent implements OnInit, OnChanges {
    /** 图片地址 */
    @Input() ncUrl: string = '';
    /** 确认裁剪回调 */
    @Output() ncConfirm = new EventEmitter();
    /** 裁剪回调返回图片格式 */
    @Input() ncImgType: NcImgType = 'base64';
    /** 容器宽度 */
    @Input() ncWidth: number = 300;
    /** 默认裁剪框的尺寸占图片比例 */
    @Input() ncClipSize: number = 0.7;
    /** 裁剪框最小宽度 */
    @Input() ncClipMinWidth: number = 50;
    /** 裁剪框最小高度 */
    @Input() ncClipMinHeight: number = 50;
    /** 确认裁剪时是否下载图片 */
    private _download: boolean = false;
    @Input() set ncDownload(value: boolean | string) {
        this._download = value !== null && value !== undefined && value !== false && value !== 'false';
    }
    get ncDownload(): boolean {
        return this._download;
    }
    /** 调整工具栏 */
    private _tool: boolean = false;
    @Input() set ncTool(value: boolean | string) {
        this._tool = value !== null && value !== undefined && value !== false && value !== 'false';
    }
    get ncTool(): boolean {
        return this._tool;
    }
    /** 上传 */
    private _upload: boolean = false;
    @Input() set ncUpload(value: boolean | string) {
        this._upload = value !== null && value !== undefined && value !== false && value !== 'false';
    }
    get ncUpload(): boolean {
        return this._upload;
    }

    hasImage: boolean = false;
    file: any;//file选择框
    clipImage: any;//裁剪背景图片
    clipPathImg: any;//裁剪使用的图片
    clip: any;//裁剪框
    // 图片当前宽高
    clipImageWidth: number = 0;
    clipImageHeight: number = 0;
    // 图片原始宽高
    clipImageOriginWidth: number = 0;
    clipImageOriginHeight: number = 0;
    scale: number = 0;//缩放比例
    clipWidth: number = 0;//裁剪框宽度
    clipHeight: number = 0;//裁剪框高度
    clipX: number = 0;//裁剪框x
    clipY: number = 0;//裁剪框y

    constructor(private eleRef: ElementRef) { }

    ngOnInit(): void {
        this.clipImage = this.eleRef.nativeElement.querySelector('#clipImage');
        this.clipPathImg = this.eleRef.nativeElement.querySelector('#clipPathImg');
        this.clip = this.eleRef.nativeElement.querySelector('#clip');
        if (this.ncUpload) {
            setTimeout(() => {
                this.file = this.eleRef.nativeElement.querySelector('#file');
                // 监听上传状态 浏览图片
                this.file.addEventListener('change', (e: any) => {
                    const file = e.target.files[0];
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.readImage(reader.result);
                    }
                })
            })
        }
        //裁剪框缩放、拖拽
        this.clipBoxZoom();
        this.clipBpxDrag();
        //读取图片
        this.readImage(this.ncUrl);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ncUrl'] && !changes['ncUrl'].firstChange) {
            this.readImage(this.ncUrl);
        }
    }

    //读取图片
    readImage(url: any) {
        // 读取到的图片数据
        this.clipImage.src = url;
        // 裁剪使用的图片
        this.clipPathImg.src = url;
        //获取当前图片的宽高
        this.getClipImageSize(url).then((res: any) => {
            // 初始化
            this.init();
            this.hasImage = true;
        })
    }

    // 获取上传图片的当前尺寸和原始尺寸
    async getClipImageSize(dataurl: any) {
        const data: any = await new Promise((resolve) => {
            this.clipImage.onload = () => {
                resolve(this.clipImage);
            };
        });
        // 获取图片当前宽高
        this.clipImageWidth = data.width;
        this.clipImageHeight = data.height;
        const data_1: any = await new Promise((resolve_1) => {
            // 获取图片原始宽高
            let img = document.createElement('img');
            img.src = dataurl;
            img.onload = () => {
                resolve_1(img);
            };
        });
        // 获取图片原始宽高
        this.clipImageOriginWidth = data_1.width;
        this.clipImageOriginHeight = data_1.height;
        return await Promise.resolve();
    }

    // 初始化
    init() {
        // 显示裁剪框
        this.clip.style.display = 'block';
        // 缩放比例
        this.scale = this.clipImageOriginWidth / this.clipImageWidth;
        // 设置裁剪框的宽高
        let clipWidth = Math.floor(this.clipImageWidth * this.ncClipSize);
        let clipHeight = Math.floor(this.clipImageHeight * this.ncClipSize);
        this.setClipSize(clipWidth, clipHeight);

        // 设置裁剪框的位置
        let x = Math.floor((this.clipImageWidth - clipWidth) / 2);
        let y = Math.floor((this.clipImageHeight - clipHeight) / 2);
        this.setClipPosition(x, y);
    }

    // 设置裁剪框的尺寸
    setClipSize(clipWidth: number, clipHeight: number) {
        this.clip.style.setProperty('--clipWidth', clipWidth + 'px');
        this.clip.style.setProperty('--clipHeight', clipHeight + 'px');
        this.clipWidth = clipWidth;
        this.clipHeight = clipHeight;
    }

    // 设置裁剪框的位置
    setClipPosition(x: number, y: number) {
        this.clip.style.setProperty('--clipX', x + 'px');
        this.clip.style.setProperty('--clipY', y + 'px');
        this.clipX = x;
        this.clipY = y;
        // 设置裁剪阴影
        this.setClipPath();
    }

    // 设置裁剪阴影
    setClipPath() {
        let lt = this.clip.offsetLeft + 'px' + ' ' + this.clip.offsetTop + 'px';
        let rt = (this.clip.offsetLeft + this.clip.offsetWidth) + 'px' + ' ' + this.clip.offsetTop + 'px';
        let rb = (this.clip.offsetLeft + this.clip.offsetWidth) + 'px' + ' ' + (this.clip.offsetTop + this.clip.offsetHeight) + 'px';
        let lb = this.clip.offsetLeft + 'px' + ' ' + (this.clip.offsetTop + this.clip.offsetHeight) + 'px';
        this.clipPathImg.style.setProperty('--clipPath', `polygon(${lt}, ${rt}, ${rb}, ${lb})`);
    }

    // 裁剪
    async clipImg(x: number, y: number, cutWidth: number, cutHeight: number, width: number, height: number) {
        let canvas: HTMLCanvasElement = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d')!.drawImage(this.clipImage, x, y, cutWidth, cutHeight, 0, 0, width, height);

        //下载
        if (this.ncDownload) {
            const a = document.createElement('a');
            a.download = '裁剪图片';
            a.href = canvas.toDataURL('image/png');
            a.click();
        }

        // 返回裁剪后的图片
        return new Promise((resolve) => {
            if (this.ncImgType == 'base64') {
                resolve(canvas.toDataURL('image/png'));
            } else {
                canvas.toBlob((blob: any) => {
                    resolve(new File([blob], 'clip.png', { type: 'image/png' }));
                })
            }
        })
    }

    //确认裁剪
    async confirm() {
        let res = await this.clipImg(this.clip.offsetLeft * this.scale, this.clip.offsetTop * this.scale, this.clip.offsetWidth * this.scale, this.clip.offsetHeight * this.scale, this.clip.offsetWidth, this.clip.offsetHeight);
        this.ncConfirm.emit(res);
    }

    //裁剪框的拖拽
    clipBpxDrag() {
        // 鼠标按下
        this.clip.onmousedown = (e: any) => {
            // 偏移量
            let py = {
                x: e.clientX - this.clip.offsetLeft,
                y: e.clientY - this.clip.offsetTop
            }
            // 鼠标移动
            window.onmousemove = (e) => {
                // 鼠标移动的距离
                let moveX = e.clientX - py.x;
                let moveY = e.clientY - py.y;
                // 裁剪框的位置
                let left = moveX;
                let top = moveY;
                // 裁剪框的位置限制
                if (left < 0) {
                    left = 0;
                }
                if (top < 0) {
                    top = 0;
                }
                if (left > this.clipImageWidth - this.clip.offsetWidth) {
                    left = this.clipImageWidth - this.clip.offsetWidth;
                }
                if (top > this.clipImageHeight - this.clip.offsetHeight) {
                    top = this.clipImageHeight - this.clip.offsetHeight;
                }
                // 设置裁剪框的位置
                this.setClipPosition(left, top);
            }
            // 鼠标松开
            window.onmouseup = () => {
                window.onmouseup = null;
                window.onmousemove = null;
            }
        }
    }

    //裁剪框缩放
    clipBoxZoom() {
        // 获取裁剪框的四个角
        let zoomDom: any = {
            lt: this.eleRef.nativeElement.querySelector('.lt'),
            rt: this.eleRef.nativeElement.querySelector('.rt'),
            rb: this.eleRef.nativeElement.querySelector('.rb'),
            lb: this.eleRef.nativeElement.querySelector('.lb'),
        };
        // 鼠标按下时的位置
        let zoomInfo = {
            x: 0,
            y: 0,
            minWidth: this.ncClipMinWidth,
            minHeight: this.ncClipMinHeight
        }
        // 鼠标按下时裁剪框的位置
        for (let key in zoomDom) {
            zoomDom[key].onmousedown = (e: any) => {
                // 禁止冒泡
                e.stopPropagation();
                // 鼠标按下时的位置
                zoomInfo.x = e.clientX;
                zoomInfo.y = e.clientY;
                // 鼠标移动
                window.onmousemove = (e) => {
                    // 鼠标移动的距离
                    let moveX = e.clientX - zoomInfo.x;
                    let moveY = e.clientY - zoomInfo.y;
                    // 裁剪框的位置 
                    let left = 0;
                    let top = 0;
                    // 裁剪框的尺寸
                    let width = 0;
                    let height = 0;

                    // 左上角
                    if (key === 'lt') {
                        // 裁剪框的位置 
                        left = this.clip.offsetLeft + moveX;
                        top = this.clip.offsetTop + moveY;
                        // 裁剪框的尺寸
                        width = this.clip.offsetWidth - moveX;
                        height = this.clip.offsetHeight - moveY;
                        // 裁剪框的位置限制
                        if (left < 0) {
                            left = 0;
                            // 原来宽度+原来left
                            width = this.clip.offsetWidth + this.clip.offsetLeft;
                        }
                        if (top < 0) {
                            top = 0;
                            // 原来高度+原来top
                            height = this.clip.offsetHeight + this.clip.offsetTop;
                        }
                    }
                    // 右上角
                    if (key === 'rt') {
                        // 裁剪框的位置
                        top = this.clip.offsetTop + moveY;
                        left = this.clip.offsetLeft;
                        // 裁剪框的尺寸
                        width = this.clip.offsetWidth + moveX;
                        height = this.clip.offsetHeight - moveY;
                        // 裁剪框的位置限制
                        if (top < 0) {
                            top = 0;
                            // 原来高度+原来top
                            height = this.clip.offsetHeight + this.clip.offsetTop;
                        }
                        if (left + width > this.clipImageWidth) {
                            // 图片当前宽-原来left
                            width = this.clipImageWidth - left;
                        }
                    }
                    // 右下角
                    if (key === 'rb') {
                        // 裁剪框的尺寸
                        top = this.clip.offsetTop;
                        left = this.clip.offsetLeft;
                        width = this.clip.offsetWidth + moveX;
                        height = this.clip.offsetHeight + moveY;
                        // 裁剪框的位置限制
                        // 当前的left+当前的width>图片当前宽
                        if (this.clip.offsetLeft + width > this.clipImageWidth) {
                            width = this.clipImageWidth - left;
                        }
                        // 当前的top+当前的height>图片当前宽
                        if (this.clip.offsetTop + height > this.clipImageHeight) {
                            height = this.clipImageHeight - top;
                        }
                    }
                    // 左下角
                    if (key === 'lb') {
                        // 裁剪框的位置
                        left = this.clip.offsetLeft + moveX;
                        top = this.clip.offsetTop;
                        // 裁剪框的尺寸
                        width = this.clip.offsetWidth - moveX;
                        height = this.clip.offsetHeight + moveY;
                        // 裁剪框的位置限制
                        if (left < 0) {
                            left = 0;
                            width = this.clip.offsetWidth + this.clip.offsetLeft;
                        }
                        // 当前的top+当前的height>图片当前宽
                        if (this.clip.offsetTop + height > this.clipImageHeight) {
                            height = this.clipImageHeight - top;
                        }
                    }
                    // 裁剪框的限制
                    ({ width, height, left, top } = this.ClipWidthPosition(zoomInfo, width, height, left, top))
                    // 设置裁剪框的位置
                    this.setClipPosition(left, top);
                    // 设置裁剪框的尺寸
                    this.setClipSize(width, height);
                    // 记录上一次的位置
                    zoomInfo.x = e.clientX;
                    zoomInfo.y = e.clientY;
                }
                // 鼠标松开
                window.onmouseup = () => {
                    window.onmouseup = null;
                    window.onmousemove = null;
                }
            }
        }
    }

    // 裁剪框的宽高限制以及位置限制
    ClipWidthPosition(zoomInfo: any, w: number, h: number, l: number, t: number) {
        let width = w;//裁剪框宽度
        let height = h;//裁剪框的高度
        let left = l;//裁剪框的left
        let top = t;//裁剪框的top
        if (w < zoomInfo.minWidth) {
            width = zoomInfo.minWidth;
            left = this.clip.offsetLeft;
        }
        if (h < zoomInfo.minHeight) {
            height = zoomInfo.minHeight;
            top = this.clip.offsetTop;
        }
        return { width, height, left, top };
    }

    //尺寸输入框变化
    sizeInputChange() {
        this.setClipSize(this.clipWidth, this.clipHeight);
        this.setClipPosition(this.clipX, this.clipY);
    }
}
